export default __webpack_public_path__ + "static/media/info-blue-icon.8855059d.svg";